import React, { createContext, useContext, useState } from 'react';

import type { ICDFList } from 'v2/services/cdfService/types';

const FiscalDocumentsContext = createContext<any>(null);

export const useFiscalDocuments = () => {
  const context = useContext(FiscalDocumentsContext);

  if (!context) {
    throw new Error('useFiscalDocuments must be used within a FiscalDocumentsProvider');
  }

  return context;
};

export const FiscalDocumentsProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectedData, setSelectedData] = useState<ICDFList[0]['list'][0]>();

  return (
    <FiscalDocumentsContext.Provider value={{ selectedData, setSelectedData }}>
      {children}
    </FiscalDocumentsContext.Provider>
  );
};
